module.exports = __webpack_public_path__ + "img/circle_star_icon.421c64e9.svg";